<h3 mat-dialog-title>Une erreur est survenue</h3>
<mat-dialog-content class=".mat-body">
  <span *ngIf="data.forced === false">Une erreur technique vient d'arriver, nous vous invitons à contacter le Service Client au 01.40.22.18.00 du lundi au vendredi de 8h30 à 17h30 pour finaliser votre adhésion.</span>
  <span *ngIf="data.forced === true">{{data.message? data.message : 'Une erreur technique vient d\'arriver, nous vous invitons à contacter le Service Client au 01.40.22.18.00 du lundi au vendredi de 8h30 à 17h30 pour finaliser votre adhésion.'}}</span>
</mat-dialog-content>
<div mat-dialog-actions>
  <button gs1Button mat-dialog-close>Fermer</button>
</div>
